// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1Jlpe","unreadBadge":"styles_unreadBadge__2gJzl","modalContent":"styles_modalContent__2Q83z","modal":"styles_modal__2gmPM"};